/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'bootstrap-daterangepicker/daterangepicker.css'
import styled from 'styled-components'
import moment, { Moment } from 'moment'
import { actions as SRIActions } from 'Slice/SRISlice';
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import { actions as ServicelineActions } from '../../Slice/ServiceLinesSlice'
import { Filter } from '../../Types/FilterTypes'
import { selectServicelineName, selectServicelineSelectedRegions } from '../../Selector/ServiceLinesSelector'
import { smMobile } from '../../Utils/utilsStyle'

const InputDatepiker = styled.div<Props>`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: 10px;
  @media all and (max-width: ${smMobile}) {
    margin-left: 6px;
  }
  ${(props) => {
    if (props.teamBoard) {
      return `
       width:100% !important
    `
    }
  }}
  .active{
    background: #DEF6E6;
    color: #09A43A;
  }
`
type DateFilterLabelObject = { start: Moment; end: Moment; label?: string };

type Props = {
  teamBoard?: boolean
  label?: string
  ranges?: { [key: string]: Moment[] }
  rangeType?: number
  isActive?: boolean
  kpmgMode?: boolean
  serviceLineId?: number
  filter?: Filter[]
  page?: number
  widgetName?: string
  name?: string
  onDateChange?: (start: Moment, end: Moment, label?: string) => void
  filters?: DateFilterLabelObject
  mainOnDateChange?: (start: Moment, end: Moment, label?: string) => void
}

const SRIDateRangePicker: React.FC<Props> = React.memo((props: Props) => {
  const dispatch = useDispatch();
  const [label, setLabel] = useState('All Time');
  const [filterType, setFilterType] = useState('All Time');
  const ranges = props.ranges;
  const filters = props.filters;
  const isActive = props.isActive;
  const kpmgMode = props.kpmgMode || false;
  const serviceLineId = props.serviceLineId;
  const page = props.page;
  const filter = props.filter;
  const widgetName = props.widgetName;
  const name = props.name;
  const selectedRegions = useSelector(selectServicelineSelectedRegions);
  const setLabelUtil = (startDate: Moment, endDate: Moment, label?: string) => {
    if (label !== 'Custom Range') {
      setLabel(label || '')
    } else {
      setLabel(startDate.format('MMM DD, YY') + ' - ' + endDate.format('MMM DD, YY'))
    }
  }

  const [state, setState] = useState(() => {
    setLabelUtil(moment(filters?.start), moment(filters?.end), filters?.label)
    return {
      start: filters ? moment(filters?.start) : moment().startOf('month'),
      end: filters ? moment(filters?.end) : moment().endOf('month'),
    }
  })

  const handleCallBack = (startDate: Moment, endDate: Moment, label?: string) => {
    setState({ start: startDate, end: endDate })
    if (props.onDateChange) {
      props.onDateChange(startDate, endDate, label)
    }
    if (props.mainOnDateChange) {
      props.mainOnDateChange(startDate, endDate, label)
    }
    setFilterType(label || '');
    if (label !== 'Custom Range')
      setLabelUtil(startDate, endDate, label)
  }

  useEffect(() => {
    if ((
      filters?.start !== undefined && filters?.end !== undefined
    ) && (state.start !== props?.filters?.start || state.end !== props?.filters?.end)) {
      setLabelUtil(filters.start, filters.end, props.label)
      setState({ start: filters.start, end: filters.end })
    }
  }, [filters])

  const handleApply = (_event: any, picker: any) => {
    if (picker.chosenLabel !== 'Custom Range') return;
    const filterObject = {
      start_date: state.start.format('YYYY-MM-DD h:mm:ss'),
      end_date: state.end.format('YYYY-MM-DD h:mm:ss'),
      type: 'Custom Range',
    };
    if (kpmgMode) {
      dispatch(ServicelineActions.setFilters(filterObject));
      const subRegions = selectedRegions.join(",");
      dispatch(ServicelineActions.getServiceLineDetails({
        id: serviceLineId ?? 0,
        dateRangeFilter: filterObject,
        ...(filter && filter.length > 0 && { filters: filter }),
        page: page,
        widget_name: widgetName,
        ...(subRegions && { regions: subRegions }),
      }))
    } else {
      dispatch(SRIActions.setFilters(filterObject));
    }
  }

  return (
    <DateRangePicker
      key={kpmgMode ? name : undefined}
      initialSettings={{
        ranges,
        startDate: state.start,
        endDate: state.end,
        viewMode: 'months',
        minViewMode: 'months',
        maxDate: new Date(),
        showCustomRangeLabel: !kpmgMode,
        // showDropdowns: true
      }}
      onCallback={handleCallBack}
      onApply={handleApply}
    >
      <InputDatepiker
        id="reportrange"
        teamBoard={props.teamBoard}
        className="form-control DateRangePiker"
      >
        <span
          className={classNames("d-flex align-items-center tabs-item", { active: isActive })}
          role="button"
          aria-label={label}
        >
          {label}
          {/* {filterIcon || filterTitle} */}
          {/* <Divider type="vertical" />
          <CaretDownOutlined /> */}
        </span>
        {/* <i className="fa fa-caret-down " style={{ position: 'absolute', right: 50 }}></i> */}
      </InputDatepiker>
    </DateRangePicker>
  )
})

export default SRIDateRangePicker
